import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose, withApollo } from 'react-apollo';
import SelectReasonModal from './SelectReasonModal';
import allAirlineAnswerOptions from '../../options/airlineAnswerOptions';
import RedirectWithFilters from '../RedirectWithFilters';
import { CreateLitigation } from '../../mutations/CreateLitigation';

class LitigationModal extends React.Component {
  state = { redirect: false };

  handleClose = reason => {
    if (!reason) return;
    const { taskId, client, claimId } = this.props;
    this.setState({ loading: true });
    client
      .mutate({
        mutation: CreateLitigation,
        variables: {
          input: {
            taskId,
            litigation: {
              claimId,
              airlineAmicableAnswer: reason
            }
          }
        }
      })
      .then(() => this.setState({ loading: false, redirect: true }))
      .catch(() => this.setState({ loading: false }));
  };

  render = () => {
    const { location } = this.props;
    const { redirect } = this.state;
    if (redirect) {
      const to = location.state ? location.state.previousPath : '';
      return <RedirectWithFilters to={to} />;
    }
    return (
      <SelectReasonModal
        {...this.props}
        operation="litigation"
        options={allAirlineAnswerOptions}
        handleClose={this.handleClose}
        isDescriptionVisible={false}
      />
    );
  };
}

export default compose(
  withRouter,
  withApollo
)(LitigationModal);



// WEBPACK FOOTER //
// ./src/component/modals/LitigationModal.js